<div
  class="emd-donut-host"
  tabindex="0"
  role="img"
  [attr.aria-label]="ariaLabel"
  (keydown)="onKeydown($event)"
  (blur)="onBlur()"
>
  <div #chart class="emd-donut-svg"></div>

  <emd-chart-states [loading]="false" [empty]="!hasData"></emd-chart-states>

  <emd-chart-tooltip
    [visible]="tooltipVisible"
    [title]="tooltipTitle"
    [rows]="tooltipRows"
    [x]="tooltipX"
    [y]="tooltipY"
    [hostWidth]="width"
    [hostHeight]="height"
  ></emd-chart-tooltip>
</div>
